import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid, TextField, Button } from "@material-ui/core";
import { AddIcon } from "@icarius-icons";
import { getAppColor } from "@icarius-app/selectors";
import { useSelector } from "react-redux";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const SelectorButton = ({ text, onClick }) => {
    const color = useSelector(getAppColor);

    return (
        <Button style={{ margin: 5 }} variant={"outlined"} disableRipple={true} onClick={onClick}>
            <AddIcon htmlColor={color} />
            {text}
        </Button>
    );
};

// Campos del resultado de la generación: quedan habilitados recién después
// de la primera respuesta del endpoint de generate.
const GeneratedFields = ({ formData, setFormValue, hasGenerated, dataTypes }) => {
    return (
        <>
            <Grid container item alignItems="center" xs={12} style={{ padding: "8px 10px", marginTop: 16 }}>
                {" "}
                {/* selectores */}
                <TextField
                    disabled={!hasGenerated}
                    required
                    fullWidth
                    helperText={`${getLocalizedString("sqlSelectorsCouldBe")}: ${(dataTypes || [])
                        .map((item) => item.key)
                        .join(", ")}`}
                    margin={"none"}
                    label={getLocalizedString("columnSelectorTypes")}
                    value={formData.selectors}
                    onChange={(e) => setFormValue(e.target.value, "selectors")}
                />
            </Grid>
            <Grid
                container
                item
                alignItems="center"
                justify="center"
                xs={12}
                style={{ marginTop: 8, marginBottom: 16 }}
            >
                {(dataTypes || []).map((item) => {
                    return (
                        <SelectorButton
                            key={item.key}
                            text={item.value}
                            onClick={() => setFormValue(`${formData.selectors},${item.key}`, "selectors")}
                        />
                    );
                })}
            </Grid>
            <Grid container item alignItems="center" xs={12} style={{ padding: "8px 10px", marginTop: 16 }}>
                {" "}
                {/* sql */}
                <TextFieldMultiline
                    disabled={!hasGenerated}
                    required
                    fullWidth
                    label="SQL"
                    rows={25}
                    margin={"none"}
                    value={formData.sql}
                    onChange={(e) => setFormValue(e.target.value, "sql")}
                    inputProps={{ spellCheck: "false" }}
                />
            </Grid>
        </>
    );
};

export default GeneratedFields;
